import { inject, Pipe, PipeTransform } from '@angular/core';
import { SettingsStoreSelector } from '@common/selectors/settings.selector';
import { formatFullName } from '@shared/utils/name/format-full-name.util';

@Pipe({
  name: 'formatFullName',
  standalone: false,
})
export class FormatFullNamePipe implements PipeTransform {
  private readonly settingsSelector = inject(SettingsStoreSelector);

  transform(firstname?: string, lastname?: string): string {
    return formatFullName(firstname ?? '', lastname ?? '', this.settingsSelector.app.locale);
  }
}
